<div class="ngdialog-content">
  <div class="modal-header">
    <mat-icon [mat-dialog-close] class="close-btn" aria-hidden="false" aria-label="Close Modal" fontIcon="close"></mat-icon>
  </div>
  <div class="dialog-container">
    <textarea [(ngModel)]="message"></textarea>
    <button class="button_primary" [mat-dialog-close]="{address_id: data.addressId, visit_id: data.visitId, message}" cdkFocusInitial>Send</button>
  </div>
</div>
